/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  BillingInterval,
  BillingOperationPreviewResponse,
  List,
  PublishedContentSite,
  SearchSpaceResult,
  Site,
  SiteAdaptiveContent,
  SiteAdaptiveJSONSchema,
  SiteAdaptiveSchema,
  SiteAdaptiveTemplateCondition,
  SiteAgentsContext,
  SiteBasename,
  SiteProxyOrigin,
  SitePublishOperationPreviewResponse,
  SiteSearchScope,
  SiteStructureItem,
  SiteStructureItemMovePosition,
  SiteStructureItemPointer,
  SiteTitle,
  SiteType,
  SiteUpgradeReason,
  SiteVisibility,
} from "./data-contracts";

/**
 * No description
 * @tags sites, critical
 * @name ListSites
 * @summary List all sites
 * @request GET:/orgs/{organizationId}/sites
 * @secure
 */

// @ts-ignore
export const listSites: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "high";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
    /** Identifier of the space to filter the sites by */
    space?: string;
    /** Filter sites by their title */
    title?: string;
    /** Filter sites by their published status */
    published?: boolean;
    /** Filter by site type */
    type?: SiteType[];
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: List & {
    items: Site[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites",
  method: "get",
  streaming: false,
  tags: ["sites", "critical"],
  criticalityLevel: "high",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name CreateSite
 * @summary Create a site
 * @request POST:/orgs/{organizationId}/sites
 * @secure
 */

// @ts-ignore
export const createSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The type of the site, defaults to Basic */
    type?: SiteType;
    /** Title of the site */
    title?: SiteTitle;
    /**
     * The visibility setting of the site determines the audience of the site.
     * * `public`: Anyone can access the site, and the site is indexed by search engines.
     * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
     * * `share-link`: Anyone with a secret token in the url can access the site.
     * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
     */
    visibility?: SiteVisibility;
    /** ID of spaces to be added to the site */
    spaces?: string[];
  };
  RequestHeaders: {};
  ResponseBody: Site;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites",
  method: "post",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites, internal
 * @name PreviewSitePublishCheckout
 * @summary Preview checkout information upon publishing a site in the organization.
 * @request GET:/orgs/{organizationId}/sites/publishing/checkout
 * @secure
 */

// @ts-ignore
export const previewSitePublishCheckout: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
  };
  RequestQuery: {
    /** The plan of the site to preview the checkout information for. */
    plan: SiteType;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SitePublishOperationPreviewResponse;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/publishing/checkout",
  method: "get",
  streaming: false,
  tags: ["sites", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name GetSiteById
 * @summary Get a site by its ID
 * @request GET:/orgs/{organizationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const getSiteById: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Site;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}",
  method: "get",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name UpdateSiteById
 * @summary Update a site
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const updateSiteById: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** Title of the site */
    title?: SiteTitle;
    /**
     * The visibility setting of the site determines the audience of the site.
     * * `public`: Anyone can access the site, and the site is indexed by search engines.
     * * `unlisted`: Anyone can access the site, and the site is not indexed by search engines
     * * `share-link`: Anyone with a secret token in the url can access the site.
     * * `visitor-auth`: Anyone authenticated through a JWT token can access the site.
     */
    visibility?: SiteVisibility;
    /** Basename for the site. For e.g. api */
    basename?: SiteBasename;
    adaptiveContent?: SiteAdaptiveContent;
    /**
     * Defines if the site will be included in the agent's context.
     * - `excluded` means that the agent will not be able to access the site.
     * - `included` means that the agent will be able to access the site.
     */
    agentsContext?: SiteAgentsContext;
    /** ID of the site-space to be used as the default at the root level. If site has sections, this will mark the default site space in the site's default section. */
    defaultSiteSpace?: string;
    /** ID of the site-section to be used as the default. */
    defaultSiteSection?: string;
    /**
     * Configure a proxy URL for a site. For example, you can use it to host the site on a subdirectory of your domain like `https://company.com/docs`.
     * Use `null` to remove the proxy.
     */
    proxy?: SiteProxyOrigin | null;
  };
  RequestHeaders: {};
  ResponseBody: Site;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}",
  method: "patch",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name DeleteSiteById
 * @summary Delete a site
 * @request DELETE:/orgs/{organizationId}/sites/{siteId}
 * @secure
 */

// @ts-ignore
export const deleteSiteById: {
  route: string;
  method: "delete";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 204 | 205;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}",
  method: "delete",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name GetSiteAdaptiveSchema
 * @summary Get the JSON schema describing the attributes expected for an Adaptive content site visitor.
 * @request GET:/orgs/{organizationId}/sites/{siteId}/adaptive-schema
 * @secure
 */

// @ts-ignore
export const getSiteAdaptiveSchema: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: SiteAdaptiveSchema;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/adaptive-schema",
  method: "get",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name UpdateSiteAdaptiveSchema
 * @summary Update the JSON schema of the attributes expected for an Adaptive content site visitor.
 * @request PUT:/orgs/{organizationId}/sites/{siteId}/adaptive-schema
 * @secure
 */

// @ts-ignore
export const updateSiteAdaptiveSchema: {
  route: string;
  method: "put";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** The JSON schema to set on the site. */
    jsonSchema: SiteAdaptiveJSONSchema;
  };
  RequestHeaders: {};
  ResponseBody: SiteAdaptiveSchema;
  ResponseStatusCode: 200 | 400;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/adaptive-schema",
  method: "put",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name ListSiteAdaptiveTemplateConditions
 * @summary List templates of conditions generated based on the site visitor schema that can be used in adaptive content expressions.
 * @request GET:/orgs/{organizationId}/sites/{siteId}/adaptive-schema/template-conditions
 * @secure
 */

// @ts-ignore
export const listSiteAdaptiveTemplateConditions: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: {
    items: SiteAdaptiveTemplateCondition[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/adaptive-schema/template-conditions",
  method: "get",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * @description Get the complete profile of a site in an organization to provide the published experience. It includes site, customization, structure, integration scripts etc.
 * @tags sites
 * @name GetPublishedContentSite
 * @summary Get a published site
 * @request GET:/orgs/{organizationId}/sites/{siteId}/published
 * @secure
 */

// @ts-ignore
export const getPublishedContentSite: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** For sites published via share-links, the share key is useful to resolve published URLs. */
    shareKey?: string;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: PublishedContentSite;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/published",
  method: "get",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name PublishSite
 * @summary Publish a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/publish
 * @secure
 */

// @ts-ignore
export const publishSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody:
    | Site
    | {
        type: "checkout";
        /** Stripe payment session ID */
        sessionId: string;
      };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/publish",
  method: "post",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name UnpublishSite
 * @summary Unpublish a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/unpublish
 * @secure
 */

// @ts-ignore
export const unpublishSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: Site;
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/unpublish",
  method: "post",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name SortSiteStructure
 * @summary Move a site space, site section or site section group to a new position in the site structure.
 * @request PATCH:/orgs/{organizationId}/sites/{siteId}/structure/sort
 * @secure
 */

// @ts-ignore
export const sortSiteStructure: {
  route: string;
  method: "patch";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: {
    /** pointer to the item (site space, site section or site section group) being moved. */
    item: SiteStructureItemPointer;
    /** The position to move the item to. When not provided the item is moved to the end of the site structure. */
    position: SiteStructureItemMovePosition;
  };
  RequestHeaders: {};
  ResponseBody: SiteStructureItem;
  ResponseStatusCode: 200 | 400 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/structure/sort",
  method: "patch",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites, internal
 * @name UpdateSitePlan
 * @summary Update the site plan.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/plan
 * @secure
 */

// @ts-ignore
export const updateSitePlan: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** The app screen URL to bring the user back to after a successful checkout. */
    successReturnURL?: string;
    /** The app screen URL to bring the user back to after a canceled checkout. */
    cancelReturnURL?: string;
  };
  RequestBody: {
    /** The type of the site */
    plan: SiteType;
    /** Desired interval for new subscriptions. Defaults to the existing billing interval. */
    interval?: BillingInterval;
    /** The reason or feature that triggered the site upgrade */
    reason: SiteUpgradeReason;
  };
  RequestHeaders: {};
  ResponseBody:
    | {
        /** User must checkout to complete the update. */
        type: "checkout";
        /** Stripe payment session ID */
        sessionId: string;
      }
    | {
        /** The site plan was successfully updated. */
        type: "success";
        /**
         * * `upgraded`: Subscription was upgraded to include the site
         * * `downgraded`: Subscription was downgraded by removing the site
         * * `no-payment-changes`: No impact on subscription (e.g. trial, unpublished)
         */
        outcome?: "upgraded" | "downgraded" | "no-payment-changes";
      };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/plan",
  method: "post",
  streaming: false,
  tags: ["sites", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites, internal
 * @name PreviewSitePlanUpdate
 * @summary Preview an upgrade to a site plan, returning checkout information.
 * @request GET:/orgs/{organizationId}/sites/{siteId}/plan
 * @secure
 */

// @ts-ignore
export const previewSitePlanUpdate: {
  route: string;
  method: "get";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** The desired site plan */
    plan: SiteType;
  };
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: BillingOperationPreviewResponse;
  ResponseStatusCode: 200 | 404;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/plan",
  method: "get",
  streaming: false,
  tags: ["sites", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites
 * @name SearchSiteContent
 * @summary Search in a site
 * @request POST:/orgs/{organizationId}/sites/{siteId}/search
 * @secure
 */

// @ts-ignore
export const searchSiteContent: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {
    /** Identifier of the page results to fetch. */
    page?: string;
    /**
     * The number of results per page
     * @min 0
     * @max 1000
     */
    limit?: number;
  };
  RequestBody: {
    /** @maxLength 512 */
    query: string;
  } & (
    | {
        /** Define the scope of the search. */
        scope: SiteSearchScope;
      }
    | {
        /**
         * Search only in the site spaces provided. Deprecated, use scope instead.
         * @deprecated
         */
        mode?: "specific";
        /** @minLength 1 */
        siteSpaceIds: string[];
      }
    | {
        /**
         * Search in the current site space and all section's defaults. Deprecated, use scope instead.
         * @deprecated
         */
        mode: "current";
        siteSpaceId: string;
      }
    | {
        /**
         * Search in all site-spaces. Deprecated, use scope instead.
         * @deprecated
         */
        mode: "all";
      }
  );
  RequestHeaders: {};
  ResponseBody: List & {
    items: SearchSpaceResult[];
  };
  ResponseStatusCode: 200;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/search",
  method: "post",
  streaming: false,
  tags: ["sites"],
  criticalityLevel: "low",
  deprecated: false,
};

/**
 * No description
 * @tags sites, internal
 * @name ApplyTemplateToSite
 * @summary Apply a template to a site.
 * @request POST:/orgs/{organizationId}/sites/{siteId}/template
 * @secure
 */

// @ts-ignore
export const applyTemplateToSite: {
  route: string;
  method: "post";
  deprecated: false | { errorRate: number; sunset?: string | undefined; message?: string | undefined };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  RequestParams: {
    /** The unique id of the organization */
    organizationId: string;
    /** The unique id of the site */
    siteId: string;
  };
  RequestQuery: {};
  RequestBody: never;
  RequestHeaders: {};
  ResponseBody: void;
  ResponseStatusCode: 201;
} = {
  route: "/orgs/{organizationId}/sites/{siteId}/template",
  method: "post",
  streaming: false,
  tags: ["sites", "internal"],
  criticalityLevel: "low",
  deprecated: false,
};
